<template>
    <ui-form-section>
        <ui-input
            label="Title"
            name="title"
            v-model="form.title"
            placeholder="Ply, Felt, etc."
            :error="form.errors.get('title')"
            @change="readOnly ? null : $emit('updated')"
            :disabled="readOnly"
        ></ui-input>
        <ui-input
            class="xl:col-span-6"
            label="NBS"
            name="nbs"
            v-model="form.nbs"
            placeholder="J42 etc"
            :error="form.errors.get('nbs')"
            @change="readOnly ? null : $emit('updated')"
            :disabled="readOnly"
        ></ui-input>
        <ui-input
            class="xl:col-span-6"
            label="Unit Of Measure"
            name="unit_of_measure"
            v-model="form.unit_of_measure"
            placeholder="m2, lm, etc."
            :error="form.errors.get('unit_of_measure')"
            @change="readOnly ? null : $emit('updated')"
            :disabled="readOnly"
        ></ui-input>
        <ui-textarea
            autoresize
            label="Note"
            name="description"
            v-model="form.description"
            :error="form.errors.get('description')"
            @change="readOnly ? null : $emit('updated')"
            :disabled="readOnly"
        ></ui-textarea>
        <ui-field label="Materials and Labour Rates">
            <global-specs-form-table
                :form="form"
                :estimate="estimate"
                :read-only="readOnly"
                @updated="readOnly ? null : $emit('updated', $event)"
            ></global-specs-form-table>
        </ui-field>
    </ui-form-section>
</template>

<script>
export default {
    props: {
        form: Object,
        estimate: Object,
        readOnly: Boolean,
    },
}
</script>
